// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"277":"95b3e4c3","404":"95b3e4c3","575":"95b3e4c3"}[chunkId] + ".chunk.css";
};